export const ACCOUNT_PAGE = '/account';

export const ALL_DATA_PAGE = '/data/allData';

export const APPLICATIONS_PAGE = '/data/applications';

export const APPLICATION_DETAILS_PAGE = '/data/applicationDetails';

export const ASSETS_PAGE = '/data/assets';

export const ASSET_DETAILS_PAGE = '/data/assetDetails';

export const BATTERY_DETAILS_PAGE = '/data/batteryDetails';

export const BOUNDARY_DETAILS_PAGE = '/data/boundaryDetails';

export const BOUNDARIES_PAGE = '/data/boundaries';

export const CREATE_BOUNDARY_PAGE = '/data/boundaryDetails/new';

export const CLIENTS_PAGE = '/data/clients';

export const CLIENT_DETAILS_PAGE = '/data/clientDetails';

export const DATA_PAGE = '/data';

export const DRONE_DETAILS_PAGE = '/data/droneDetails';

export const FARMS_PAGE = '/data/farms';

export const FARM_DETAILS_PAGE = '/data/farmDetails';

export const FIELDS_PAGE = '/data/fields';

export const FIELD_DETAILS_PAGE = '/data/fieldDetails';

export const HOME_PAGE = '/';

export const LOGIN_PAGE = '/login';

export const LOGOUT_PAGE = '/logout';

export const MAINTENANCE_PAGE = '/maintenance';

export const ONBOARDING_CURRENT_USER_PAGE = '/onboarding/currentUser';

export const ONBOARDING_ORGANIZATION_CREATION_PAGE = '/onboarding/organizationCreation';

export const REPORTS_PAGE = '/reports';

export const SIGNUP_PAGE = '/signup';

export const SUPPORT_PAGE = '/support';

export const USERS_PAGE = '/data/users';

export const USER_DETAILS_PAGE = '/data/userDetails';

export const VERIFY_EMAIL_PAGE = '/onboarding/verify/email';
